import { toast } from "react-toastify";
import { sortRequests } from "../utils/sortRequests";
import axiosInstance from "../api/axiosInstance";
import { STATUS } from "../components/constants/statuses";

export const updateRequestStatus =
  ({ setRequests }) =>
  (id, newStatus) => {
    setRequests((prevRequests) => {
      const updatedRequests = prevRequests.map((req) => {
        if (String(req.id) === String(id)) {
          return { ...req, status: newStatus };
        } else {
          return req;
        }
      });
      return sortRequests(updatedRequests);
    });
  };

export const handlePlayed =
  ({ isOnline, token, updateRequestStatus }) =>
  async (id, userId, artist, trackName) => {
    if (!isOnline) {
      toast.error("You are offline. Go online to make this action");
      return;
    }

    try {
      const messageData = {
        requestId: id,
        userId,
        artist,
        trackName,
        status: STATUS.PLAYED,
      };

      await axiosInstance.patch(
        `/request/${id}/update?status=played`,
        messageData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      updateRequestStatus(id, STATUS.PLAYED);
    } catch (error) {
      toast.error("Failed to mark as played");
    }
  };
